/**
 * @prettier
 */
import * as React from 'react';
import { OrderSummaryOld } from 'src/components/OrderSummaryOld';
import { useSelector } from 'src/utils/react/useSelector';

export function CartSummary(): React.ReactElement | null {
    const hasNoPayment = useSelector((state) => !state.app.payment);
    const subtotal = useSelector((state) => state.app.payment?.subtotal);
    const productDiscount = useSelector((state) => state.app.payment?.productDiscount);
    const promoCodeDiscount = useSelector((state) => state.app.payment?.promoCodeDiscount);
    const customerDeliveryCost = useSelector((state) => state.app.payment?.customerDeliveryCost);
    const driverTip = useSelector((state) => state.app.driverTip);
    const tax = useSelector((state) => state.app.payment?.tax);
    const taxRate = useSelector((state) => state.app.payment?.taxRate);
    const companyCredits = useSelector((state) => state.app.payment?.companyCredits);
    const letsEatCredits = useSelector((state) => state.app.payment?.letsEatCredits);
    const total = useSelector((state) => state.app.payment?.total);
    const companyName = undefined; // const companyName = useSelector(state => state.app.company?.name);
    const currencyFormat = useSelector((state) => state.app.restaurantMenu?.currencyFormat);

    if (hasNoPayment) {
        return null;
    }

    return (
        <OrderSummaryOld
            subtotal={subtotal}
            productDiscount={productDiscount}
            promoCodeDiscount={promoCodeDiscount}
            customerDeliveryCost={customerDeliveryCost}
            driverTip={driverTip}
            tax={tax}
            taxRate={taxRate}
            companyCredits={companyCredits}
            companyName={companyName}
            letsEatCredits={letsEatCredits}
            total={total}
            currencyFormat={currencyFormat}
        />
    );
}
